import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger"];
  static values = {
    className: String
  };

  toggle(event) {
    this.element.classList.toggle(this.classNameValue);
    this.focusOtherTrigger(event.currentTarget);
  }

  // The pressed trigger is hidden by the toggle, so keep focus on the one that takes its place.
  focusOtherTrigger(pressed) {
    this.triggerTargets.find((trigger) => trigger !== pressed)?.focus();
  }
}
